<template>
    <!-- TODO: Better class name!-->
    <div class="v-atlas-raumplanung-request-options-panel">
        <!--#region Request options controls-->
        <template v-for="(entry, key) in options" :key="key">
            <div :data-help="entry.contextHelpId">
                <h3 v-html="props.options?.[key]?.label" />

                <component :is="componentMap[entry.type]" :option="entry" :model-value="_settings[key]"
                    :settings="_settings" :view-stack-controller="props.viewStackController"
                    @update:model-value="onUpdate(key, $event)" />
            </div>
        </template>
        <!--#endregion Request Options controls-->
    </div>
</template>


<script setup lang="ts">

import { computed } from 'vue';
import { RequestOptions, RequestSettings } from 'atlas-shared';
import RequestOptionsListItem from './RequestOptionsList.vue';
import RequestOptionsDropdownItem from './RequestOptionsDropdown.vue';
// TODO: This import of a specific submodule file is a little bit ugly
import RequestOptionsAttributeSelectorItem from '../../mapModules/raumplanung/RequestOptionsAttributeSelector.vue';
import RequestOptionsTimeRangeItem from './RequestOptionsTimeRange.vue';
import RequestOptionsTimePointItem from './RequestOptionsTimePoint.vue';
import { ViewStackController } from 'gertrud';

const componentMap: Record<string, any> = {
    List: RequestOptionsListItem,
    Dropdown: RequestOptionsDropdownItem,
    AttributeSelector: RequestOptionsAttributeSelectorItem,
    TimeRange: RequestOptionsTimeRangeItem,
    TimePoint: RequestOptionsTimePointItem,
};

const props = withDefaults(defineProps<{
    options?: RequestOptions
    settings?: RequestSettings
    viewStackController: ViewStackController
}>(), {
    options: () => ({}),
    settings: () => ({}),
})

const emit = defineEmits<{
    'update:settings': [settings: any]
}>()

const _settings = computed({
    get: () => props.settings,
    set: (val) => emit('update:settings', val)
})

/**
 * Handle an option update. For most option types the emitted value is the new
 * value for the single settings key. For a `TimeRange` option the emitted value
 * is an object of `{ timeRangeEarliest, timeRangeLatest }` that must be merged
 * into the settings object.
 */
function onUpdate(key: string, value: any) {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        emit('update:settings', { ..._settings.value, ...value })
    }
    else {
        emit('update:settings', { ..._settings.value, [key]: value })
    }
}


</script>
